export const BlockLabel = (props) => {
    const { label, icon } = props;
    const datas = props.datas ? props.datas : [];
    let legend, name;
    switch (label) {
        case 'Categorie':
        case 'Public':
        case 'Durée':
        case 'Hauteur':
        case 'Longueur':
        case 'Vitesse':
        case 'Capacité':
        case 'Evacuation':
        case 'Taille':
            legend = (label === 'Taille') ? props.name : label;
            name = (label === 'Taille') ? props.description : props.name;
            return (
                <div className="info-tech">
                    <div className="icon">
                        <div className={icon}></div>
                    </div>
                    <div className="legend">
                        <div className="label">{legend}</div>
                        <div className="name">{name}</div>
                    </div>
                </div>
            )
        case 'Intérets':
        case 'Handicaps':
            if (datas && datas.length > 0) {
                return (
                    <div className="info-tech">
                        <div className="icon">
                            <div className={icon}></div>
                        </div>
                        <div className="legend">
                            <div className="label">{label}</div>
                            {datas.map((el, i) => {
                                return (
                                    <div key={i}>
                                        <div className="name">{el.name}</div>
                                        <div className="describe">{el.description}</div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                )
            }
        default:
            return (
                <></>
            )
    }

}